import type { DatasetLoaderProps } from "./dataset-loader.type";

import { Skeleton } from "antd";

export const DatasetLoader = ({ type }: DatasetLoaderProps) => {
  if (type === "file") {
    return <Skeleton.Button active />;
  }

  return <Skeleton active />;
};
